import React from 'react';

/** Lazy ClientComputedPlaylist (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedPlaylist = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-playlist' */
            './ClientComputedPlaylist'
        ),
);
